import { render, staticRenderFns } from "./EmbebbedDashboard.vue?vue&type=template&id=a96d4d88&"
import script from "./EmbebbedDashboard.vue?vue&type=script&lang=js&"
export * from "./EmbebbedDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports